/**
 * "em 25 min" / "em 1h 30min" / "agora" — usado no chip e no modal de
 * detalhes do próximo compromisso, sempre a partir do mesmo `now` (evita os
 * dois textos discordarem por causa de re-render em momentos diferentes).
 */
export const formatAppointmentCountdown = (start, now) => {
  const diffMin = Math.max(Math.round((start.getTime() - now.getTime()) / 60000), 0);
  if (diffMin < 1) return 'agora';
  if (diffMin < 60) return `em ${diffMin} min`;
  const hours = Math.floor(diffMin / 60);
  const minutes = diffMin % 60;
  return minutes > 0 ? `em ${hours}h ${minutes}min` : `em ${hours}h`;
};
